import {LayerController} from './layer.controller';
import {NGSIResult} from '../../shared/models/ngsi/ngsi-result';
import {catchError, forkJoin, Observable, of} from 'rxjs';
import {map} from 'rxjs/operators';
import {Layer} from '../../shared/models/layer.model';
import {Page} from '../../shared/models/page.model';
import {Injector} from '@angular/core';
import {Marker} from '../../shared/models/map/marker.model';
import {NGSIQuery} from '../../shared/models/ngsi/ngsi-query.model';
import {NGSIFilter} from '../../shared/models/ngsi/ngsi-filter.model';
import {QueryOptions} from '../../shared/models/ngsi/query-options';
import {NGSIEntity} from '../../shared/utils/ngsi-result-util';


export class OcppChargePointLayerController extends  LayerController {
  displaysTooltip: boolean = true;
  constructor(layer: Layer, page: Page, private injector: Injector) {
    super(layer, page, injector);
  }

  protected getDialogContext(result: NGSIResult): any {
    const query: NGSIQuery = new NGSIQuery();
    query.filter = new NGSIFilter();

// Charge point id of the marked entity is read
    const chargePointId = result.getEntityResult().entity.id;
    let contextObservable: Observable<any> = null;

// ocppChargePointQuery is set by the filter id == charge point id
    const ocppChargePointQuery: NGSIQuery = new NGSIQuery({
      filter: {
        type: [NGSIEntity.OCPP_CHARGE_POINT],
        q : {
          jsonClass: 'NGSIQueryTerm',
          path: {
            jsonClass: 'NGSIPath',
            propOrRelPath: [
              'id'
            ],
            isTemporal: false,
            isPropOrRelArray: false
          },
          op: '==',
          value: [
            chargePointId
          ]
        }
      },
      limit: 100,
      lastNDays: 365
    });

// ocppConnectorQuery is set by the filter refid == charge point id
    const ocppConnectorQuery: NGSIQuery = new NGSIQuery({
      filter: {
        type: [NGSIEntity.OCPP_CONNECTOR],
        q : {
          jsonClass: 'NGSIQueryTerm',
          path: {
            jsonClass: 'NGSIPath',
            propOrRelPath: [
              'refId'
            ],
            isTemporal: false,
            isPropOrRelArray: false
          },
          op: '==',
          value: [
            chargePointId
          ]
        }
      },
      limit: 100,
      lastNDays: 365
    });

// ocppAuthorizeQuery is set by the filter refid == charge point id
    const ocppAuthorizeQuery: NGSIQuery = new NGSIQuery({
      filter: {
        type: [NGSIEntity.OCPP_AUTHORIZE],
        q : {
          jsonClass: 'NGSIQueryTerm',
          path: {
            jsonClass: 'NGSIPath',
            propOrRelPath: [
              'refId'
            ],
            isTemporal: false,
            isPropOrRelArray: false
          },
          op: '==',
          value: [
            chargePointId
          ]
        }
      },
      limit: 1,
      lastNDays: 365
    });

// ocppBootNotificationQuery is set by the filter refid == charge point id
    const ocppBootNotificationQuery: NGSIQuery = new NGSIQuery({
      filter: {
        type: [NGSIEntity.OCPP_BOOT_NOTIFICATION],
        q : {
          jsonClass: 'NGSIQueryTerm',
          path: {
            jsonClass: 'NGSIPath',
            propOrRelPath: [
              'refId'
            ],
            isTemporal: false,
            isPropOrRelArray: false
          },
          op: '==',
          value: [
            chargePointId
          ]
        }
      },
      limit: 1,
      lastNDays: 365
    });

// Charge point, connector, authorize and boot notification values are read from the database via cbroker service
    const ocppChargePointRef =  this.cbrokerService.getEntities(ocppChargePointQuery, new QueryOptions(false)).pipe(catchError(() => of(null)));
    const ocppConnectorRef =  this.cbrokerService.getEntities(ocppConnectorQuery, new QueryOptions(false)).pipe(catchError(() => of(null)));
    const ocppAuthorizeRef =  this.cbrokerService.getEntities(ocppAuthorizeQuery, new QueryOptions(false)).pipe(catchError(() => of(null)));
    const ocppBootNotificationRef =  this.cbrokerService.getEntities(ocppBootNotificationQuery, new QueryOptions(false)).pipe(catchError(() => of(null)));

    contextObservable = forkJoin([ocppChargePointRef, ocppConnectorRef, ocppAuthorizeRef, ocppBootNotificationRef]).pipe(
      map(response => {
        return {
          entity: response[0],
          ocppConnectorEntity: response[1],
          ocppAuthorizeEntity: response[2],
          ocppBootNotificationEntity: response[3]
        };
      })
    );
    return {
      page: this.popupPage,
      entity: result.getEntityResult(),
      asyncContext: contextObservable
    };
  }

// Description info is displayed as the tooltip of the marker
  createTooltip(marker: Marker): string {
    const description = marker.entity.getSingleElementValue('description');
    let html = '<div class="entity-tooltip">';
    html += `<div class="text">${description}</div>`;
    html += '</div>';

    return html;
  }

}
